<header id="header" class="fixed-top" (activate)="onActivate($event)">
  <div class="container">
    <div class="logo float-left">
      <a class="navbar-brand" [routerLink]="['/']" rel="tooltip"
         title="Coded by Iruobe Akhigbe" data-placement="bottom">
        <div class="diff">
          <span class="colorChange">College</span>Dreams
        </div>
      </a>
    </div>
    <nav class="main-nav float-right d-none d-lg-block">
      <ul>
        <li>
          <a [routerLink]="['/']">
            About
          </a>
        </li>
        <li>
          <a [routerLink]="['/']">
            Features
          </a>
        </li>
        <li>
          <a href="javascript:void(0)" (click)="scrollToContact()">
            Contact
          </a>
        </li>
        <li>
          <a class="loginbutton" [routerLink]="['/login']">
            <i class="fas fa-sign-in-alt"></i>
            &nbsp; Login
          </a>
        </li>
      </ul>
    </nav>
  </div>
</header>

<div class="page-header header-filter" data-parallax="true" style="background-image:
url('../../.././assets/img/pexels.jpeg'); height: 983px">
  <div class="container">
    <div class="row form-div">
      <div class="col-md-12">
        <h4 class="title text-center">
          <a style="color: #ffffff;" [routerLink]="['/']"> Home </a>
          <i class="fas fa-angle-double-right"></i>
          Online Admissions
        </h4>
        <h2 class="text-center">
          Apply for admission into any school <br> of your choice.
        </h2>
        <div class="col-lg-6 col-md-6 col-sm-6 ml-auto mr-auto">
          <div class="card form-box">
            <form novalidate  #loginForm="ngForm" (ngSubmit)="goToPreviewPage()">
              <div *ngIf="true" class="card-body">
                <!--<span class="font-weight-bold red" >{{ errorMessage | titlecase }}</span>-->
                <!--Select School-->
                <div class="bmd-form-group pb-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                    </div>
                    <select class="js-example-responsive form-control custom-select"
                            #school="ngModel" id="school"
                            name="school"
                            [(ngModel)]="credentials.schools"
                            [ngModelOptions]="{standalone: true}">
                      <option value="" class="select-option"> &nbsp; Select School</option>
                      <option value="{{school.schoolId}}" class="select-option2" *ngFor="let school of schools" >
                        {{school.schoolName}}
                      </option>
                    </select>
                    <div *ngIf="isValidated && school.errors?.required" class="alert alert-danger mt-2">
                      Select a School from the Dropdown
                    </div>
                  </div>
                  <div class="fa-div">
                    <i class="fa fa-sort fa-1x" aria-hidden="true"></i>
                  </div>
                </div>
                <!--<div class="bmd-form-group pb-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                    </div>
                    <ng-select class="form-control ng-select-form"
                               id="Location" #Location="ngModel"
                               placeholder="Select Location"
                               [(ngModel)]="credentials.schools"
                               [ngModelOptions]="{standalone: true}">
                      &lt;!&ndash;<ng-template ng-header-tmp>
                        <input style="width: 100%; line-height: 24px" type="text" placeholder="Search..." (input)="Location.filter($event.target.value)"/>
                      </ng-template>&ndash;&gt;
                      <ng-option [value]="school?.id" class="select-option2" *ngFor="let school of schools" >
                        {{school.address.city}}
                      </ng-option>
                    </ng-select>
                  </div>
                </div>-->
                <!--Student Name-->
                <div class="bmd-form-group pb-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                    </div>
                    <input type="text" class="form-control" placeholder="  Student Name"
                           #StudentName="ngModel" id="StudentName"
                           [(ngModel)]="credentials.StudentName" [ngModelOptions]="{standalone: true}" required autocomplete="false">
                    <!-- minlength="4"-->
                  </div>
                </div>
                <!--Date Of Birth-->
                <div class="bmd-form-group pb-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                    </div>
                    <input type="text" class="form-control " placeholder="  Date Of Birth" #password="ngModel"
                           id="DateOfBirth" [(ngModel)]="credentials.DateOfBirth" [ngModelOptions]="{standalone: true}" required autocomplete="false">
                    <!-- minlength="8"-->
                  </div>
                </div>
                <!--Previous School-->
                <div class="bmd-form-group pb-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                    </div>
                    <input type="text" class="form-control " placeholder="  Previous School" #password="ngModel"
                           id="PreviousSchool" [(ngModel)]="credentials.PreviousSchool" [ngModelOptions]="{standalone: true}" required autocomplete="false">
                    <!-- minlength="8"-->
                  </div>
                </div>
                <!--Previous Class-->
                <div class="bmd-form-group pb-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                    </div>
                    <input type="text" class="form-control " placeholder="  Previous Class" #password="ngModel"
                           id="PreviousClass" [(ngModel)]="credentials.PreviousClass" [ngModelOptions]="{standalone: true}" required autocomplete="false">
                    <!-- minlength="8"-->
                  </div>
                </div>
                <!--New Class-->
                <div class="bmd-form-group pb-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                    </div>
                    <input type="text" class="form-control " placeholder="  New Class" #password="ngModel"
                           id="NewClass" [(ngModel)]="credentials.NewClass" [ngModelOptions]="{standalone: true}" required autocomplete="false">
                    <!-- minlength="8"-->
                  </div>
                </div>
              </div>

              <div class="card-footer justify-content-center">
                <button type="submit" class="preview-button mt-2">
                  <!--<button type="submit" class="btn btn-warning btn-lg" [disabled]="password.errors || email.errors || loading">-->
                  <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
                  Preview
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--==========================
 Header
 ============================
<header id="header" class="fixed-top">
  <div class="container">

    <div class="logo float-left">
       Uncomment below if you prefer to use an image logo
       <h1 class="text-light"><a href="#header"><span>NewBiz</span></a></h1>
      <a [routerLink]="['/']" class="scrollto"><img src="../../../assets/images/MwareCollegeDreamsWeb.png" alt="" class="img-fluid">
        <b class="logoText"> <span class="colorChange">College</span>Dreams </b></a>
    </div>

    <nav class="main-nav float-right d-none d-lg-block">
      <ul>
        <li>
          <a [routerLink]="['/login']">
            About
          </a>
        </li>
        <li>
          <a [routerLink]="['/login']">
          Features
        </a>
        </li>
        <li>
          <a href="javascript:void(0)" (click)="scrollToContact()">
            Contact
          </a>
        </li>
        <li>
          <a [routerLink]="['/login']" target="_blank">
            <i class="fa fa-sign-in"></i>
            Login
          </a>
        </li>
      </ul>
    </nav> .main-nav

  </div>
</header> #header

==========================
  Intro Section
============================
<section id="intro" class="clearfix">
  <div class="container">

    <div class="intro-img">
    <img src="img/intro-img.svg" alt="" class="img-fluid">
    </div>

    <div class="intro-info">
      <h2>Zamfara State<br>Scholarship Board</h2>
      <div>
        <a href="#services" class="btn-get-started scrollto">Get Started</a>
        <a href="#why-us" class="btn-services scrollto">Basic Requirements</a>
      </div>
    </div>

  </div>
</section> #intro -->
<app-sign-up2></app-sign-up2>
